import React from "react";
import withStyles from "react-jss";
import InlineSVG from "ComponentsUI/Inlinesvg";
import classNames from "classnames";

const styles = (theme) => {
	return {
		root: {
			borderRadius: "10px",
			height: "40px",
			display: "flex",
			alignItems: "center",
			padding: "0 11px",
			marginTop: "10px",
			marginRight: "10px",
			position: "relative",
			overflow: "hidden",
			zIndex: 0,
		},
		progress: {
			position: "absolute",
			top: 0,
			bottom: 0,
			left: 0,
			right: "50%",
			zIndex: "-1",
		},
		logo: {
			lineHeight: 0,
			marginRight: "10px",
			"& svg": {
				width: "24px",
				height: "24px",
				fill: theme.palette.colors.yellow,
				"& path": {
					fill: theme.palette.colors.yellow,
				},
			},
		},
		name: {
			fontFamily: "MuseoSansCyrl-500",
			fontSize: "14px",
			lineHeight: "1.29",
			color: theme.palette.colors.white,
			marginRight: "7px",
		},
		value: {
			fontFamily: "MuseoSansCyrl-500",
			fontSize: "14px",
			lineHeight: "1.29",
			color: theme.palette.colors.yellow,
		},
		whiteTheme: {
			border: `solid 1px ${theme.palette.colors.disabled}`,
			"& $progress": {
				display: "none",
			},
			"& $logo": {
				"& svg": {
					fill: theme.palette.colors.disabled,
					"& path": {
						fill: theme.palette.colors.disabled,
					},
				},
			},
			"& $name": {
				color: theme.palette.colors.darkSlateBlue,
			},
			"& $value": {
				color: theme.palette.colors.oneMoreGrey,
			},
		},
	};
};

const RatingLine = (props) => {
	let classes = props.classes;
	let styles = {
		backgroundColor: props.color,
	};
	let item = props.item;
	return (
		<div
			className={classNames(classes.root, {
				[classes.whiteTheme]: props.whiteTheme,
			})}
			style={styles}
		>
			<div
				className={classes.progress}
				style={{
					right: 100 - parseInt(item.value) * 10 + "%",
					backgroundColor: styles.backgroundColor,
				}}
			/>
			<div className={classes.logo}>
				<InlineSVG src={item.image}>
					<svg width="24" height="24">
						<image xlinkHref={item.image} width="48" height="44" />
					</svg>
				</InlineSVG>
			</div>
			<div className={classes.name}>{item.name}</div>
			<div className={classes.value}>{item.value}</div>
		</div>
	);
};

RatingLine.defaultProps = {
	item: {},
	color: "rgba(44, 29, 93, 0.1)",
};

export default withStyles(styles)(RatingLine);

export { RatingLine as __RatingLine };
